
import { mdiClose } from "@mdi/js"
export default {
    name: "CreateDialog",
    data() {
        return {
            mdiClose,
        }
    },
    computed: {
        createItems() {
            const items = [
                {
                    image: require("@/assets/images/thinking.svg"),
                    header: "Neue Stelle",
                    subheader:
                        "Finden Sie die passenden Praktikanten und Azubis, indem Sie Stellen inserieren!",
                    event: "create-job",
                    routerLink: {
                        name: "betriebe-slug-jobs-erstellen",
                        params: { slug: this.$auth.user.business.slug },
                    },
                },
                {
                    image: require("@/assets/images/writing.svg"),
                    imgClass: "offset",
                    header: "Neuer Beitrag",
                    subheader:
                        "Halten Sie Jugendliche über News aus dem Unternehmen auf dem Laufenden!",
                    routerLink: {
                        name: "betriebe-slug-beitraege-erstellen",
                        params: { slug: this.$auth.user.business.slug },
                    },
                },
            ]
            if (this.$can.admin()) {
                items.push({
                    image: require("@/assets/images/writing.svg"),
                    imgClass: "offset",
                    header: "Neues Event",
                    subheader:
                        "Erstellen Sie über neue Veranstaltungen in Ihrer Region!",
                    routerLink: {
                        name: "admin-event-erstellen",
                    },
                })
            }

            return items
        },
    },
}
